export default function truncateString(source?: string | null, size?: number) {
  if (!source) {
    return '';
  }

  const sliceSize = size ?? 50;

  return source.length > sliceSize ? source.slice(0, sliceSize - 1) + '…' : source;
}
